<div class="scroll-container">
    <lib-breadcrumb [list]="breadcrumbs()"></lib-breadcrumb>
    <div class="text-lg mb-5 flex items-center">
        <div class="text-lg font-semibold text-gray-800">
            {{isSupremeCourtFlg || isCOAFlg ? 'Pending Appeals':'Pending Cases'}}
        </div>
        <button mat-flat-button class="ml-auto" color="primary" [disabled]="isLoading()" (click)="onCaseSearch()">
            <mat-icon fontIcon="refresh" class="!mr-0"></mat-icon>
        </button>
    </div>

    <div class="flex bg-fieldset p-4 mb-3 items-end gap-4">
        <!-- Case Stage Select -->
        <div class="flex flex-col gap-1.5 w-60">
            <label for="caseStage" class="text-sm font-medium text-gray-700 flex items-center min-h-[20px]">
                Case Stage
            </label>
            <select id="caseStage" [formControl]="searchTypeCtrl"
                class="h-[42px] rounded border border-gray-300 bg-white px-3 text-sm shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 box-border">
                <option value="hearing">Hearing</option>
                <option value="judgement">Judgement</option>
            </select>
        </div>

        <!-- Case Number Input -->
        <div class="flex flex-col w-96">
            <app-case-number-search [label]="userType === 'lawyer' ? 'Case Number' : 'Appeal Number'"
                (caseSelected)="onCaseSearchOptionSelected($event)" formControlName="caseNumber">
            </app-case-number-search>
        </div>

        <!-- Search Button -->
        <div class="flex items-center">
            <button type="submit" mat-flat-button color="primary" [disabled]="isLoading()" (click)="onCaseSearch()"
                class="!h-[42px] px-6">
                @if (isLoading()) {
                <mat-spinner diameter="18" class="mr-2 inline-block"></mat-spinner>
                }
                Search
            </button>
        </div>
    </div>
    <!-- Table Container with Overlay Spinner -->
    <div class="flex pb-3 relative">
        @if (isLoading()) {
        <div class="absolute inset-0 bg-white/70 z-10 flex items-center justify-center">
            <mat-spinner diameter="40" color="primary"></mat-spinner>
        </div>
        }

        <div class="flex-grow bg-fieldset">
            <cdk-virtual-scroll-viewport itemSize="48" [class]="dataSource.data.length > 5 ? 'h-96' : 'h-32'"
                maxItemsToRender="5">
                <table mat-table matSort [dataSource]="dataSource" class="case-summery-table">
                    <ng-container [matColumnDef]="column.dataIndex"
                        *ngFor="let column of hearingScheduleTbl().columns; let $index = index;">
                        @if (column.sortable == false) {
                        <th mat-header-cell *matHeaderCellDef [class]="column.headingStyleClass"> {{column.title}} </th>
                        } @else {
                        <th mat-header-cell *matHeaderCellDef mat-sort-header [class]="column.headingStyleClass">
                            {{column.title}}
                        </th>
                        }
                        <td mat-cell *matCellDef="let row" [class]="column.styleClass">
                            @switch (column.dataIndex) {
                            @case ('hearingDate') {
                            {{row[column.dataIndex] ? (row[column.dataIndex] | date: 'mediumDate') : ''}}
                            }
                            @case ('judgementDate') {
                            {{row[column.dataIndex] ? (row[column.dataIndex] | date: 'mediumDate') : ''}}
                            }
                            @case ('appealNumber') {
                            <div class="flex items-center">
                                <a (click)="appealNumberClickHandler(row)" class="cursor-pointer text-primary">
                                    {{row[column.dataIndex]}}
                                </a>
                            </div>
                            }
                            @default {
                            {{row[column.dataIndex]}}
                            }
                            }
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true">
                    </tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns();" class="table-row-item"
                        (click)="appealNumberClickHandler(row)">
                    </tr>
                </table>
            </cdk-virtual-scroll-viewport>
        </div>
    </div>

    @if (caseNumber()) {
    <app-case-documents [caseNumber]="caseNumber()"></app-case-documents>
    }
</div>